import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { CountryProvider } from './hooks/useCountry';
import { initMetaPixel } from './utils/metaPixel';
import { NewHomePage } from './pages/NewHomePage';
import { TryDemoPage } from './pages/TryDemoPage';
import { ServicesPage } from './pages/ServicesPage';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { SystemMessageConfigPage } from './pages/SystemMessageConfigPage';
import { WhatsAppDashboardPage } from './pages/WhatsAppDashboardPage';
import { HelpGoogleSheetsPage } from './pages/HelpGoogleSheetsPage';
import { HelpShopifyPage } from './pages/HelpShopifyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { PricingPage } from './pages/PricingPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { SubscriptionPage } from './pages/SubscriptionPage';
import { AccountSuspendedPage } from './pages/AccountSuspendedPage';
import { PaymentSuccessPage } from './pages/PaymentSuccessPage';
import { PaymentFailedPage } from './pages/PaymentFailedPage';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div data-id="element-0">Loading...</div>;
  }
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" data-id="element-1" />;
}
export function App() {
  // Initialize Meta Pixel on app load
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountryProvider data-id="element-2">
      <AuthProvider data-id="element-3">
        <BrowserRouter data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<NewHomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/try-demo" element={<TryDemoPage data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<AboutPage data-id="element-11" />} data-id="element-10" />
            <Route path="/blog" element={<BlogPage data-id="element-13" />} data-id="element-12" />
            <Route path="/blog/:slug" element={<BlogPage data-id="element-15" />} data-id="element-14" />
            <Route path="/pricing" element={<PricingPage data-id="element-17" />} data-id="element-16" />
            <Route path="/privacy" element={<PrivacyPolicyPage data-id="element-19" />} data-id="element-18" />
            <Route path="/terms" element={<TermsPage data-id="element-21" />} data-id="element-20" />
            <Route path="/services" element={<ServicesPage data-id="element-23" />} data-id="element-22" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-25" />} data-id="element-24" />
            <Route path="/login" element={<LoginPage data-id="element-27" />} data-id="element-26" />
            <Route path="/register" element={<RegisterPage data-id="element-29" />} data-id="element-28" />
            <Route path="/account-suspended" element={<AccountSuspendedPage data-id="element-31" />} data-id="element-30" />
            <Route path="/subscription" element={<ProtectedRoute data-id="element-33">
                  <SubscriptionPage data-id="element-34" />
                </ProtectedRoute>} data-id="element-32" />
            <Route path="/payment/success" element={<ProtectedRoute data-id="element-36">
                  <PaymentSuccessPage data-id="element-37" />
                </ProtectedRoute>} data-id="element-35" />
            <Route path="/payment/failed" element={<ProtectedRoute data-id="element-39">
                  <PaymentFailedPage data-id="element-40" />
                </ProtectedRoute>} data-id="element-38" />
            <Route path="/dashboard" element={<ProtectedRoute data-id="element-42">
                  <DashboardPage data-id="element-43" />
                </ProtectedRoute>} data-id="element-41" />
            <Route path="/dashboard/:section" element={<ProtectedRoute data-id="element-45">
                  <DashboardPage data-id="element-46" />
                </ProtectedRoute>} data-id="element-44" />
            <Route path="/whatsapp-dashboard" element={<ProtectedRoute data-id="element-48">
                  <WhatsAppDashboardPage data-id="element-49" />
                </ProtectedRoute>} data-id="element-47" />
            <Route path="/onboarding" element={<ProtectedRoute data-id="element-51">
                  <OnboardingPage data-id="element-52" />
                </ProtectedRoute>} data-id="element-50" />
            <Route path="/configure" element={<ProtectedRoute data-id="element-54">
                  <SystemMessageConfigPage data-id="element-55" />
                </ProtectedRoute>} data-id="element-53" />
            <Route path="/help/google-sheets-oauth" element={<HelpGoogleSheetsPage data-id="element-57" />} data-id="element-56" />
            <Route path="/help/shopify-integration" element={<HelpShopifyPage data-id="element-59" />} data-id="element-58" />
            <Route path="/Admin-dashboard" element={<AdminDashboardPage data-id="element-61" />} data-id="element-60" />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </CountryProvider>;
}